(() => {
  'use strict';

  window.IS_TOUCH_DEVICE = 'ontouchend' in document || !!navigator.msMaxTouchPoints || (navigator.maxTouchPoints > 1);
  window.IS_IOS = (/\biP(hone|ad|od)\b/i.test(navigator.platform) || /\biP(hone|ad|od)\b/i.test(navigator.userAgent) || (((navigator.platform === 'MacIntel') || navigator.userAgent.includes('Mac')) && IS_TOUCH_DEVICE)) && !window.MSStream;
  window.IS_MOBILE = IS_IOS || /\b(Android|BlackBerry|IEMobile|Opera Mini|webOS|Windows Phone)\b/i.test(navigator.userAgent);
  window.IS_DESKTOP = !IS_MOBILE;
})();